import { Button } from "design-system/atoms/Button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "design-system/molecules/DropdownMenu"
import { Plus } from "lucide-react"
import { useTranslation } from "react-i18next"
import { MetafieldGroup } from "./MetafieldsKeyList"

type AddButtonProps = { onAdd: (group: MetafieldGroup) => void }

const METAFIELD_GROUPS: MetafieldGroup[] = ["product", "productVariant", "order"]
const TAG_GROUPS: MetafieldGroup[] = ["productTags", "orderTags"]
const PROPERTY_GROUPS: MetafieldGroup[] = ["lineItemProperty"]

export const MetafieldsAddButton = ({ onAdd }: AddButtonProps) => {
  const { t } = useTranslation()
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button type="button" variant="outline" size="sm">
          <Plus className="size-4 mr-1" />
          {t("settings.integrations.shopify.metafields.addEntry")}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>
          {t("settings.integrations.shopify.metafields.kind.metafield")}
        </DropdownMenuLabel>
        <DropdownMenuGroup>
          {METAFIELD_GROUPS.map((group) => (
            <DropdownMenuItem key={group} onSelect={() => onAdd(group)}>
              {t(`settings.integrations.shopify.metafields.field.${group}`)}
            </DropdownMenuItem>
          ))}
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        <DropdownMenuLabel>
          {t("settings.integrations.shopify.metafields.kind.tag")}
        </DropdownMenuLabel>
        <DropdownMenuGroup>
          {TAG_GROUPS.map((group) => (
            <DropdownMenuItem key={group} onSelect={() => onAdd(group)}>
              {t(`settings.integrations.shopify.metafields.field.${group}`)}
            </DropdownMenuItem>
          ))}
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        <DropdownMenuLabel>
          {t("settings.integrations.shopify.metafields.kind.property")}
        </DropdownMenuLabel>
        <DropdownMenuGroup>
          {PROPERTY_GROUPS.map((group) => (
            <DropdownMenuItem key={group} onSelect={() => onAdd(group)}>
              {t(`settings.integrations.shopify.metafields.field.${group}`)}
            </DropdownMenuItem>
          ))}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
